const state = {
    brands: [
        "Logo-dpsp-black.png",
        "Bioritmo_logo.png",
        "nos.png",
        "LOGO_RACE-01.png",
        "TONUSGYM-B.png",
        "JAB-HOUSE-B.png",
        "VIDYA-B.png",
        "qd-marca_preta.png"
    ]
}

export {state}